import React, { useEffect, useContext, useState, useActionState } from 'react';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Input_Text_Long from '../ERUMAUI/UI_Input_Text_Long';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import UI_Button from '../ERUMAUI/UI_Button';
import Document_Schedule from './Document_Schedule';

export default function Subwindow_ScheduleManagement_Document({ zIndex, isActive, id }) {
    const UI = useContext(Context_UI);
    const { Template_List } = useTemplating();
    const { Schedule_Information } = useScheduleManagement();
    const Close = () => {
        UI.Subwindows_Close(id);
    }


    return (
        <ui-subwindow Type='Subwindow' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    Schedule document
                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Close}>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content style={{ minHeight: "500px", paddingRight: "10px" }}>
                <Document_Schedule Data={Schedule_Information} />
            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Close}>
                    Close
                </button>
            </ui-subwindow-controls>
        </ui-subwindow>

    );
}
